<template>
  <button class="btn " type="button">
    <slot></slot>
  </button>
</template>

<script>
export default {
  name: "Button",
}
</script>

<style scoped>

</style>